import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '../components/Pagination';
import { useSearchExport } from '../context/SearchExportContext';
import { getInvoices } from '../redux/invoiceSlice';
import ExportDropdown from '../context/ExportDropdown';
import RecordsLoader from '../components/RecordsLoader';

const InvoiceList = () => {
    const dispatch = useDispatch();
    const { invoices, status } = useSelector((state) => state.invoices);
    const { filterData } = useSearchExport();

    const [currentPage, setCurrentPage] = useState(1);
    const invoicesPerPage = 10;

    useEffect(() => {
        dispatch(getInvoices());  // Fetch all invoices on component load
    }, [dispatch]);

    const currentInvoices = filterData(invoices || [])
        .slice((currentPage - 1) * invoicesPerPage, currentPage * invoicesPerPage);

    return (
        <div className="container mx-auto p-6">

            {/* Render the loader if the status is 'idle' */}
            {status === 'idle' && <RecordsLoader text="Loading invoices, please hold on..." />}

            <h1 className="text-2xl text-black font-bold mb-6">invoices List</h1>

            {/* Export Buttons */}
            <ExportDropdown data={invoices} fileName="invoices" />

            {status === 'failed' && <p>Error loading invoices</p>}

            {/* Open Call List Table */}
            {status === 'succeeded' && (
                <>
                    <table className="min-w-full table-auto bg-white shadow-md rounded-lg">
                        <thead>
                            <tr className="bg-gray-100 text-left">
                                <th className="px-4 py-2">User Email</th>
                                <th className="px-4 py-2">Product</th>
                                <th className="px-4 py-2">Amount</th>
                                <th className="px-4 py-2">Payment ID</th>
                                <th className="px-4 py-2">Payment Date</th>
                                <th className="px-4 py-2">View</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(invoices?.length > 0) ? (
                                currentInvoices.map((invoice, index) => (
                                    <tr key={index} className="border-b cursor-pointer hover:bg-gray-100">
                                        <td className="px-4 py-2 bg-yellow-500">{invoice?.user_email || 'N/A'}</td>
                                        <td className="px-4 py-2 bg-gray-300">{invoice?.product || 'N/A'}</td>
                                        <td className="px-4 py-2 bg-green-500">${invoice?.amount?.toFixed(2) || '0.00'}</td>
                                        <td className="px-4 py-2 bg-red-500">{invoice?.payment_id || 'N/A'}</td>
                                        <td className="px-4 py-2 bg-purple-500">{invoice?.payment_date || 'N/A'}</td>
                                        <td className="px-4 py-2 bg-gray-100">
                                            {invoice?.invoice_path ? (
                                                <a
                                                    href={invoice.invoice_path}
                                                    className="w-24 h-10 flex items-center justify-center px-2 py-1 bg-blue-500 text-white rounded ml-2"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    View
                                                </a>
                                            ) : (
                                                <span className="text-gray-400">No Invoice</span>
                                            )}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="6" className="text-center py-4 bg-gray-50">No Invoices Found!</td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    {/* Pagination */}
                    {invoices?.length > invoicesPerPage && (
                        <Pagination
                            usersPerPage={invoicesPerPage}
                            totalUsers={invoices.length}
                            paginate={setCurrentPage}
                            currentPage={currentPage}
                        />
                    )}
                </>
            )}
        </div>
    );
};

export default InvoiceList;